/** Demo 仅展示 claimflow测试2 及其关联项目/漏洞 */
export const DEMO_PROJECT_ID = '756673a8-ad64-475e-84d1-8ffef7421931';
export const DEMO_TASK_ID = 'b8b07d32-d7d5-4efa-8695-60d7e1250ff1';
export const DEMO_TASK_NAME = 'claimflow测试2';
export const DEMO_PROJECT_NAME = 'claimflow-demo';
export const DEMO_TOKEN = 'demo-argusmind-vercel-token';
